/*
命名规范
1. 小写驼峰
2. 特殊情况可特殊处理（如 侧边栏，导航栏等直接关联key的词可以采用大写驼峰）
standard  通用标准字段
login  登录
register 注册
resetPassword 忘记密码（找回密码/密码重置)
modifyPassword 修改密码 (公共组件)
cookies cookies政策（公共组件)
slideCircus 滑块拼图验证码（公共组件)
message 消息提醒
verify 表单校验提示
placeholder 表单项描述输入字段预期值的提示信息
tagsView 图钉功能相关
exit 退出登录相关
notFind 404
settings 整体相关
role 权限相关
button 按钮
accountInfo 账号信息
baseInfo 基本信息
emailLink 邮箱链接
accountSecurity 账户安全
*/

export default {
  'standard': {
    '用户不存在': '該帳號未註冊，請先前往注册後再登入',
    'no_zone_code': '(無需區號)',
    '授权校验失败，请刷新页面并重试。': '授權校驗失敗，請刷新頁面並重試。',
    'onlineService': '在<br/>線<br/>客<br/>服',
    'standardExpress': '國際標快',
    'economyExpress': '國際特惠',
    'eParcel': '國際小包',
    'overseasFulfilment': '國際電商專遞',
    'warehouse': '海外倉',
    'pleaseAgreePolicy': '請先閱讀並同意《隱私政策》	',
    'pleaseAgreeToScan': '請先閱讀並同意右側協議',
    'heavyFreight': '國際重貨',
    '验证码接收方式': '驗證碼接收方式',
    'cancelTips': '您的帳號還未綁定手機號或郵箱，請先前往綁定後才能通過身份認證做註銷操做。',
    'confirmCancel': '確認註銷',
    'verificationCodeError': '驗證碼錯誤，請重新獲取驗證碼！',
    'clickGoDirectly': '(點擊直接前往)',
    'repeatTips': '您的帳號存在重複問題，請前往<span class="mode">選擇登入方式</span>後登入，{count}秒後自動跳轉',
    'repeatTips1': '您的手機號存在重複問題，請前往<span class="mode">選擇區號</span>後登入，{count}秒後自動跳轉',
    'goOldLogin': '舊版登入',
    'goNewLogin': '新版登入',
    'siteTips': '為獲得更好的系統使用體驗，您可以選擇切換到另一個國家或地區',
    'siteGo': '前往',
    'loginLoading': '帳號自動登錄新系統，請稍候',
    'sfExpress': 'KEX速運 版權所有 粵ICP備08034243號',
    'kex': 'KEX',
    'iuopOsPatent': 'Copyright© ABX EXPRESS (M) SDN BHD. All Rights Reserved.	',
    'unite': '國際認證服務中心',
    'jumpError': '跳轉地址不合法',
    'tips': '提示',
    'tips1': '溫馨提示',
    'confirm': '確認',
    'agreeAndContinue': '我已閱讀並同意《隱私政策》',
    'agreeService': '我已閱讀並同意《服務條款》',
    'agreeUserAgreement': '我已閱讀並同意 《用戶協議》',
    'define': '確定',
    'cancel': '取消',
    'yes': '是',
    'no': '否',
    'sendAgain': '重新發送',
    'second': ' 秒',
    'iknow': '我知道了',
    'country': '國家/地區',
    'tel': '手機號',
    'email': '郵箱',
    'telNumber': '手機號碼',
    'verifyCode': '驗證碼',
    'sendVerificationCode': '發送驗證碼',
    'next': '下一步',
    'prev': '上一步',
    'finished': '完成',
    'back': '返回',
    'backLogin': '返回登錄',
    'home': '國際官網',
    'home_os': 'ABX Express',
    'inquiry': '查詢',
    'add': '新增',
    'edit': '編輯',
    'del': '刪除',
    'batchDel': '批量刪除',
    'operating': '操作',
    'clearInfo': '清空信息',
    'excelUpload': 'Excel上傳',
    'serialNumber': '序號',
    'save': '保存',
    'leastOne': '請先勾選要刪除的數據',
    'uploadFile': '上傳文件',
    'downloadExcel': '下載EXCEL模板',
    'pleaseInput': '請輸入',
    'pleaseSelect': '請選擇',
    'isDel': '確定刪除選擇的數據嗎？',
    'agree': '同意',
    'disagree': '不同意',
    'uploadTotal': '上傳總數',
    'uploadSuccess': '上傳成功',
    'uploadFail': '上傳失敗',
    'checkAll': '全選',
    'cancelContent': '該帳號於[{cancelTime}]提交註銷，15天內登入則重新啟動，是否繼續登入？',
    'ok': '好的', // V1.5
    'autoTip': '正在鑒權中，請等待...',
    'feedback': '功能反饋/建議',
    'scanCode': '掃碼登錄',
    'useWxScan': '使用微信掃一掃',
    'useWhatsAppScan': '使用WhatsApp掃一掃',
    'otherLoginWays': '其他登入方式',
    'scanSuccessfully': '掃碼成功',
    'confirmOnPhone': '請在手機上確認',
    'refreshQR': '點擊刷新',
    'consult': '合作諮詢',
    'please_select_correct_phone': '請選擇正確手機區號',
    '国际标快': '國際標快',
    '国际特惠': '國際特惠',
    '顺丰集运': '順豐集運',
    '国际电商专递': '國際電商專遞',
    '国际小包': '國際小包',
    '海外仓': '海外倉',
    '顺丰国际产品导航': '產品導航'
  },
  'channel': {
    'gls': 'GLS 海外連盟',
    'gls_tooltip': '請在郵件正文填寫登入帳號，郵件主題【GLS忘記密碼】，發送郵件至 wuzipeng@sf-express.com'
  },
  'login': {
    'toLogin': '去登入',
    'account': '帳號',
    'accountRepeativeTitle': '帳號重複處理',
    'accountRepeativeDesc': '您的帳號存在重複，需要您確認將以哪一個帳號登入系統，您也可以選擇登入後註銷或換綁其中一個帳號，避免後續再次出現同類情况。',
    'accountType': '帳號類型',
    'aciton': '操作',
    'merge': '三要素融合版',
    'unique': '三要素獨立版',
    'selectLoginType': '選擇登錄方式',
    'personal': '個人登錄',
    'enterprise': '企業登錄',
    'tel': '手機號',
    'password': '密碼',
    'verificationCodeLogin': '驗證碼登錄',
    'verificationCode': '驗證碼',
    'obtainVerificationCode': '獲取驗證碼',
    'passwordLogin': '密碼登錄',
    'rememberPSD': '記住我',
    'rememberTips': '不推薦在公共設備上選擇',
    'forgetPSD': '忘記密碼',
    'loginAgree': '我已閱讀並同意',
    'agreeTips': '《隱私政策》',
    'userAgreement': '《用戶協議》',
    'login': '登錄',
    'username': '用戶名',
    'email': '郵箱',
    'phoneLogin': '手機號登錄',
    'usernameLogin': '用戶名登錄',
    'emailLogin': '郵箱登錄',
    'usernameOrEmailLogin': '用戶名/郵箱登錄',
    'registerNow': '立即註冊',
    'pleaseInput': '請輸入',
    'and': '和',
    'sfbuy_privacy': '《KEX集運服務協定》',
    'sfbuy_title': 'KEX集運',
    'aboutUs': '關於我們',
    'serviceGuide': '新手指南',
    'helpCenter': '幫助中心',
    'serviceAndPrice': '服務與價格',
    'onlineCSR': '線上客服',
    'copyright': 'Copyright ©2023 KEX速運 版權所有'
  },
  'register': {
    'personal': '個人用戶註冊',
    'enterprise': '企業用戶註冊',
    'tel': '手機號',
    'telVerificationCode': '手機驗證碼',
    'email': '郵箱',
    'emailVerificationCode': '郵箱驗證碼',
    'sendVerificationCode': '發送驗證碼',
    'password': '輸入密碼',
    'passwordAgain': '重輸密碼',
    'agree': '我已同意',
    'termsOfService': '《服務條款》',
    'SFBuyService': '《KEX集運服務協定》',
    'and': '和',
    'privacyPolicy': '《隱私政策》',
    'registerNow': '立即註冊',
    'haveUserName': '已有帳號？',
    'loginNow': '立即登錄',
    'toEmail': '郵箱註冊',
    'toTel': '手機註冊',
    'invitationCode': '邀請碼',
    'timeCount': '（剩餘{count}s，請閱讀至末尾）',
    'readBottom': '（請閱讀至末尾）',
    'isFinshRead': '請閱讀並同意條款信息'
  },
  'resetPassword': {
    'resetTel': '手機重置',
    'resetEmail': '郵箱重置',
    'tel': '手機號',
    'telVerificationCode': '手機驗證碼',
    'email': '郵箱',
    'emailVerificationCode': '郵箱驗證碼',
    'sendVerificationCode': '發送驗證碼',
    'newPassword': '新密碼',
    'confirmNewPassword': '確認新密碼',
    'resetPassword': '重置密碼',
    'back': '返回',
    'login': '登錄',
    'register': '註冊'
  },
  'modifyPassword': {
    'changePassword': '修改密碼',
    'old': '舊密碼',
    'new': '新密碼',
    'confirm': '確認新密碼'
  },
  'cookies': {
    // v1.4.sp4开始
    'tip1': '我們的網站使用cookie來優化用戶體驗和分析。我們可能會與我們的分析合作夥伴共享您的信息。我們的',
    'tip2': '《Cookie政策》',
    'tip3': '提供更多的信息。如需更改您的設置，請點擊',
    'tip4': '這裏',
    'tip5': '。點擊同意，即表示您同意我們根據您的偏好使用cookies。',
    'disAgree': '拒絕',
    'cookieSet': 'Cookie設置',
    'preference': '偏好類',
    'optimisation': '優化類',
    'analytics': '分析類',
    'neddCheck': '必須先勾選偏好類',
    // v1.4.sp4结束
    'cookie': 'Cookie政策',
    'agree': '同意',
    'preferenceCenter': '偏好中心' // V1.6
  },
  'slideCircus': {
    'title': '請完成下方拼圖驗證',
    'change': '換一換',
    'right': '請按住滑塊向右拖動完成拼圖',
    'pass': '驗證通過',
    'verifyText': '請點擊按鈕進行驗證',
    'verifying': '拼圖驗證中...',
    'loading': '圖片加載中'
  },
  'message': {
    'slideError': '滑塊服務調用失敗',
    'selectTerms': '請查看並勾選條款資訊',
    'verifyPass': '請點擊按鈕進行驗證',
    'registerSuccess': '註冊成功',
    'sendTips0': '發送成功',
    'resetPasswordTips0': '密碼重置成功',
    'loginTips0': '登錄成功',
    'loginTips1': '登入成功，帳號已啟動',
    'modifiedTips0': '修改成功',
    'switchLanguage': '成功切換語言',
    'switchSite': '成功切換國家',
    'changeTel': '恭喜您，您的手機修改成功，請重新登錄！',
    'ChangeEmail': '恭喜您，您的郵箱修改成功，請重新登錄！',
    'cancelSuccess': '恭喜您，您的帳號註銷成功！',
    'imgType': '請重新選擇圖片，圖片僅支持上傳JPG和PNG格式！',
    'imgSize': '請重新選擇圖片，圖片大小不能超過3MB！',
    'sumbitSuccess': '提交成功',
    'setSuccess': '設置成功',
    'delSuccess': '刪除成功',
    'addSuccess': '新增成功',
    'fileType': '請重新選擇文件，文件僅支持xls、xlsx的格式！',
    'fileSize': '請重新選擇文件，文件大小不能超過15MB！',
    'delError': '刪除失敗，請稍後重試',
    'uploadFile': '請上傳文件',
    'uploadFileSuccess': '上傳成功',
    'selectedOne': '清關資料或出生日期至少填寫壹種',
    'imgTips1': '請上傳{imgType}格式的圖片',
    'imgTips2': '單張圖片不能超過3MB',
    'imgTips3': '單張圖片不能超過10MB',
    'imgTips4': '暫不支持PDF文件預覽',
    'checkProduct': '請選擇產品',
    'clauseAgree': '請同意《電子運單契約條款》',
    'estimatedCost': '請在附加服務表格輸入預估費用',
    'cardCode': '請在附加服務表格輸入代收貨款卡號',
    'threeTips': '物品信息填寫不完善，請重新檢查',
    'fourTips': '下單信息填寫不完善，請重新檢查',
    'noNeedUpload': '無需上傳證件',
    'phoneOrFixAtLeastOne': '手機號、固定電話請至少填寫壹個',
    'customerOrderNo': '請輸入客戶訂單號', // V1.5
    'mas_003038': '您的登錄賬號出現異常，請刷新頁面再嘗試下單。',
    'mas_003038_HTM': '您的登錄（手機號碼）出現異常，請刷新頁面再嘗試 下單。',
    'mas_003035': '您的账号已经注冊過，請直接從IUOP登入下國際件單。',
    'mas_auth_failed': '鑑權失敗',
  },
  'verify': {
    'selectAreaCode': '請選擇國家/區號',
    'telTips': '請輸入手機號',
    'telError': '請輸入正確的手機號',
    'companyNameTrue': '請輸入正確的公司名稱',
    'fixMobileCode': '請選擇固定電話區號',
    'fixMobileNumber': '請輸入固定電話號碼',
    'fixMobileNumberReg': '請輸入正確的固定電話號碼',
    'mobileVerificationCode': '請輸入手機驗證碼',
    'emailAddress': '請輸入郵箱',
    'emailTips': '請輸入正確的郵箱',
    'emailVerificationCode': '請輸入郵箱驗證碼',
    'password': '請輸入密碼',
    'passwordError': '密碼為8-20位，僅支持大小寫字母、數字和符號三種及以上的組合',
    'passwordAgain': '請再次輸入密碼',
    'passwordNotSame': '兩次輸入密碼不一致',
    'usernameTips': '請輸入用戶名',
    'usernameEmailTips': '請輸入用戶名/郵箱',
    'telEmailTips': '請輸入手機號(無需區號)/郵箱',
    'fixTelEmailTips': '請輸入正確的手機號(無需區號)/郵箱',
    'selectTerms': '請查看並勾選條款資訊',
    'accountName': '支持以字母開頭,可包含字母、數字及下劃線的6-20個字符',
    'verifyType': '請選擇驗證方式',
    'verifyCode': '請輸入驗證碼',
    'lastNameRequired': '姓氏不能為空',
    'firstNameRequired': '名字不能為空',
    'genderRequired': '性別不能為空',
    'birthdayRequired': '生日不能為空',
    'certTypeRequired': '證件類型不能為空',
    'certNoRequired': '證件號不能為空',
    'certExpireDateRequired': '證件有效期不能為空',
    'notSupTips': '不支持數字和其他特殊字符',
    'certImage': '請上傳證件圖片後再提交',
    'commodityName': '請輸入托寄物品名稱',
    'quantity': '請輸入數量',
    'unit': '請選擇單位',
    'unitPrice': '請輸入單價',
    'placeOfOrigin': '請選擇原產地',
    'over0': '請輸入大於0的數字',
    'decimal3': '只支持小數點後3位',
    'decimal6': '只支持小數點後6位',
    'decimal10': '只支持小數點後10位',
    'productRecordNo': '請輸入正確的國檢備案號',
    'hsCode': '請輸入正確的海關編碼',
    'productCustomsNo': '請輸入正確的海關備案號',
    'contact': '請輸入姓名',
    'companyName': '請輸入公司名稱',
    'country': '請選擇國家/地區',
    'regionFirst': '請選擇省市區',
    'roadName': '請輸入道路名',
    'buildingNumber': '請輸入建築編號',
    'addressDetail': '請輸入詳細地址',
    'addressDetailTrue': '請輸入正確的詳細地址',
    'postalCode': '請輸入郵編',
    'phoneNumber': '請輸入手機號碼',
    'numberDecimal': '請輸入數字',
    'bangmecho': '請輸入番目町',
    'shippingType': '請選擇寄件類型',
    'clearanceInfo': '請選擇證件類型',
    'idNumber': '請輸入證件號碼',
    'idNumberIsTrue': '請輸入正確的證件號碼',
    'contactCn': '請輸入正確的中文名',
    'receiveType': '請選擇收件類型',
    'imgNumber': '至少上傳{number}張圖片',
    'papersTime': '請選擇證件有效時間',
    'declaredCurrency': '請選擇幣種',
    'requred': '此字段必填',
    'parcelTotalWeight': '請輸入總重量',
    'contentMaxLength18': '內容長度在1和18之間',
    'contentIntOrFloatMaxLength': '最多支持12位整數，10位小數',
    'atLeastSelectTip': '請至少選中壹條記錄',
    'invitationCode': '請輸入正確的邀請碼',
    'characterLength': '長度不超過{length}字符',
    'pickUpTime': '請選擇預約上門取件時間',
    'onlyNumberAndLetter': '僅支持數字字母組合',
    'serviceFee': '最多支持12位整數，2位小數',
    'methoedCode': '最多支持20位數字',
    'contentInt14OrFloat2MaxLength': '最多支持14位整數，2位小數',
    'contentInt10OrFloat6MaxLength': '最多支持10位整數，6位小數',
    'contentInt18OrFloat6MaxLength': '最多支持18位整數，6位小數',
    'timeZoneCode': '請選擇時區',
    'contentInt14OrFloat1MaxLength': '最多支持14位整數，1位小數',
    'contentInt15OrFloat5MaxLength': '最多支持15位整數，5位小數'
  },
  'placeholder': {
    'countryCode': '請選擇國家/區號',
    'telCode': '區號',
    'phoneCode': '請輸入手機號',
    'mobileVerificationCode': '請輸入手機驗證碼',
    'verificationCode': '請輸入驗證碼',
    'emailAddress': '請輸入郵箱',
    'emailVerificationCode': '請輸入郵箱驗證碼',
    'password': '請輸入密碼',
    'checkPassword': '請再次輸入密碼',
    'enter': '請輸入',
    'username': '用戶名可用於登錄',
    'cardType': '請選擇證件類型',
    'uploadCard': '與證件資訊保持一致',
    'uploadCardId': '請輸入有效的證件號碼',
    'passwordError': '密碼為8-20位，僅支持大小寫字母、數字和符號三種及以上的組合',
    'passwordAgain': '再次輸入新密碼',
    'verifyType': '請選擇驗證方式',
    'newEmail': '請輸入您常用的郵箱地址',
    'addressBook': '請輸入姓名/公司名稱查詢',
    'goodsWarehouse': '請輸入托寄物品名稱/海關編碼查詢',
    'clearanceWaybill': "請輸入12位數字運單號或'SF'開頭的15位運單號",
    'parcelTotalLength': '請輸入長',
    'parcelTotalWidth': '請輸入寬',
    'parcelTotalHeight': '請輸入高',
    'senderReason': '請選擇寄件原因',
    'tradeCondition': '請選擇貿易條件',
    'senderReasonContent': '請填寫非商業寄件原因',
    'businessRemark': '請填寫商業發票備註',
    'pickupAppointTime': '選擇日期時間（取件時間在您預約3小時內）',
    'remarkText': '可手動輸入文字',
    'payMethod': '請選擇付款方式',
    'payMonthCard': '請輸入月結賬號',
    'taxPayMethod': '請選擇稅金付款方式',
    'taxPayMonthCard': '請輸入稅金結算賬號',
    'serviceFee': '請輸入預估費用',
    'feeCard': '請輸入代收貨款卡號',
    'invitationCode': '請輸入注册/貴賓邀請碼',
    'willBay': '請輸入運單號',
    'senderCountry': '請選擇原寄地',
    'receiverCountry': '請選擇目的地',
    'receiverContact': '請輸入收件人姓名',
    'orderStatus': '請選擇訂單狀態',
    'startTime': '開始日期',
    'to': '至',
    'endTime': '結束日期',
    'timeZoneCode': '請選擇時區'
  },
  'tagsView': {
    'refresh': '刷新',
    'close': '關閉',
    'closeOthers': '關閉其他',
    'closeAll': '關閉所有'
  },
  'exit': {
    'title': '退出登錄',
    'message': '確認退出？',
    'success': '退出成功！',
    'cancel': '取消退出！',
    'close': '註銷成功'
  },
  'notFind': {
    'oops': '404',
    'info': '抱歉，您訪問的頁面不存在',
    'backHome': '返回主頁'
  },
  'settings': {
    'title': 'KEX下單平臺'
  },
  'role': {
    'admin': '管理員',
    'user': '普通用戶'
  },
  'route': {
    'Login': '登錄',
    '顺丰国际产品导航': '產品導航',
    'Register': '註冊',
    'ResetPassword': '找回密碼',
    'UserCenter': '個人中心',
    'MyInfomation': '我的資料',
    'AccountInfomation': '帳號資訊',
    'BaseInfomation': '基本資訊',
    'AccountSecurity': 'KEX下單平臺',
    'ProtocolManage': '簽署管理',
    'BindingEmail': '綁定郵箱',
    'BindingPhone': '綁定手機',
    'CancelAccount': '註銷帳號',
    'ChangeEmail': '修改郵箱',
    'ChangePassword': '修改密碼',
    'ChangePhone': '修改手機',
    'Name': '設置用戶名',
    'ToMail': '我要寄件',
    'MailProduct': '寄件產品',
    'AddressBook': '地址簿',
    'GoodsWarehouse': '物品庫',
    'Order': '訂單管理',
    'OrderIndex': '訂單列表',
    'OrderAdd': '單票下單',
    'Clearance': '清關資料',
    'UploadPhotoid': '證件上傳',
    'EditOrder': '訂單編輯',
    'ImportOrder': '导入订单', // v1.5
    'Task': '任务列表', // v1.5
    'ImportList': '导入', // v1.5
    'ExportList': '导出', // v1.5
    'permission': '权限管理', // v1.2
    'permission_system': '系統管理', // v1.2
    'permission_role': '角色管理', // v1.2
    'permission_resource': '資源權限', // v1.2
    'permission_user': '用戶管理', // v1.2
  },
  'button': {
    'sumbit': '提交'
  },
  'accountInfo': {
    'username': '用戶名稱：',
    'firstname': '名字：',
    'lastname': '姓氏：',
    'sex': '性別：',
    'man': '男',
    'woman': '女',
    'telNumber': '手機號碼：',
    'telNumberNot': '您的帳號還沒有綁定手機號碼',
    'email': '郵箱：',
    'emailNot': '您的帳號還沒有綁定郵箱',
    'binding': '立即綁定 > ',
    'changeTel': '修改手機 > ',
    'changeEmail': '修改郵箱 > ',
    'validated': '已驗證',
    'autoGeneration': '自動生成',
    'usernameTips': '用戶名設置之後不能修改',
    'birthday': '出生日期：',
    'birthday1': '出生日期',
    'autoCreate': '自動生成'
  },
  'baseInfo': {
    'cardType': '證件類型：',
    'firstname': '名字：',
    'lastname': '姓氏：',
    'cardId': '證件號碼：',
    'cardTime': '證件有效期：',
    'cardImg': '證件圖片：',
    'cardLangTime': '永久有效',
    'uploadImg': '上傳圖片',
    'titleTips': '溫馨提示：國家實行寄件實名制，並用於海關清關，證件資訊將設置清關專用浮水印，KEX將保證您的資訊安全。',
    'dialogTitle': '標準示例',
    'dialogTips': '上傳的身份證照片四角完整，文字清晰，無反光遮擋，如果模糊，太暗，可能會認證失敗！',
    'cardUp': '證件正面',
    'cardDown': '證件反面'
  },
  'emailLink': {
    'tips': '請設置帳號密碼',
    'setPassword': '設置密碼',
    'success': '帳號已啟動成功'
  },
  'accountSecurity': {
    'ChangePassword': '修改密碼',
    'ChangePasswordDesc': '若長時間未登錄導致密碼忘記，可驗證身份後，修改密碼。',
    'BindingPhone': '綁定手機',
    'BindingPhoneDesc': '綁定手機可用於手機登錄、找回密碼、下單等服務。',
    'BindingEmail': '綁定郵箱',
    'BindingEmailDesc': '綁定郵箱可用於郵箱登錄、找回密碼、下單等服務。',
    // V1.2开始
    'SettingName': '設置用戶名',
    'SettingNameDesc': '用戶名可作為登錄賬號，設置之後不可修改',
    'firstname': 'first name',
    'lastname': 'last name',
    'SettingRealName': 'Set First name&Last name	',
    'SettingRealNameDesc': 'Set personal name information as an account attribute that can be edited multiple times.',
    'immediatelySet': '立即設置',
    'alreadySet': '已設置',
    'settingComplete': '設置完成',
    'alreadyBinding': '已綁定',
    'userName': '用戶名稱',
    'userNameLogin': '用戶名可用於登錄',
    'selfCreate': '自動生成',
    'stopEdit': '用戶名設置之後不能再修改',
    'setOk': '設置完成',
    // V1.2结束
    //  V1.3.SP3 账号注销开始
    'cancelAccount': '帳號註銷',
    'cancelAccountTips': '註銷後數據無法恢復，請謹慎操作',
    'toCancel': '立即註銷',
    'cancelToKnow': '帳號註銷協定',
    'cancelDesc1': '1、本帳號為KEX國際統一帳號，一旦在KEX國際相關平臺申請註銷，被註銷後的帳號在KEX國際的平臺都將無法使用和恢復，請您謹慎操作，在操作之前自行備份帳戶相關的所有資訊和數據；',
    'cancelDesc2': '2、申請註銷即表示您自願放弃帳號內所有會員權益和虛擬資產（包括但不限於會員積分、會員等級及會員權益、優惠券等）；',
    'cancelDesc3': '3、註銷後，您將無法再登入、使用本帳號，也將無法找回您帳號中及與帳號相關的任何內容或資訊，包括但不限於：用戶名、頭像等（運單資訊將按照隱私政策約定的時限保存，您可通過運單號在KEX官網査詢貨件路由資訊）；',
    'cancelDesc4': '4、如您已開通月結帳號，註銷後，本帳號與您的月結帳戶綁定關係將解除，如需繼續使用月結帳號，需重新綁定新的帳號；',
    'cancelDesc5': '5、註銷本帳號並不代表本帳號註銷前的帳號行為和相關責任得到豁免或減輕；',
    'cancelDesc6': '6、本註銷申請可在15天內取消，自註銷之日起15天內，用戶可通過重新登入取消帳號註銷申請。',
    'cancelAgree': '我已閱讀並同意《賬號注銷協議》',
    'cancelTitle': '註銷帳號',
    'cancelConfirm': '是否確定立即註銷帳號？',
    'cancelTips': '請閱讀並同意帳號註銷協定',
    //  V1.3.SP3 账号注销结束
    'goBinding': '立即綁定',
    'changeBinding': '立即換綁',
    'auth': '身份認證',
    'finish': '修改完成',
    'binding': '綁定完成',
    'verifyType': '驗證方式',
    'ChangePhone': '修改手機',
    'ChangeEmail': '修改郵箱',
    'tips1': '恭喜您，您的密碼修改成功',
    'tips2': '恭喜您，您的手機修改成功',
    'tips3': '恭喜您，您的郵箱修改成功',
    'tips4': '恭喜您，您的手機綁定成功',
    'tips5': '恭喜您，您的郵箱綁定成功',
    'tips6': '恭喜您，用戶名設置成功',
    pleaseFirst: '請先',
    or: '或者'
  },
  'accountConflict': {
    'title': '賬戶信息確認',
    'desc1': '您好！',
    'desc2': '系統檢測到您的郵箱/手機註冊過我司多個系統。</br>為了提升體驗，請您選擇其中一個登錄帳號作為多個系統的統一登錄帳號。',
    'desc3': '點擊“確認”後，系統將向您的郵箱/手機發送修改密碼連結，請根據提示操作並妥善保管。',
    'loginName': '登錄名',
    'phone': '手機',
    'registerSys': '註冊系統',
    'registerTime': '註冊時間',
    'newRegister': '新註冊',
    'infoVer': '信息驗證',
    'inforVerSelect': '請選擇您的驗證方式',
    'selectOne': '請您選擇其中一個登錄帳號',
    'IBS': '海外下單發件管理系統',
    'ICAS': '國際統一賬號管理平臺',
    'IUOP': ' 國際統一訂單平臺',
    'IBSE': '國際商家物流出口',
    'PMS': '國際商家物流進口',
    'IBSI': '國際商家物流進口',
    'SFBUY': '海購豐運',
    'POP': '供應商開放平臺',
    'SFGOAPP': 'KEX國際下單平臺',
    'IFTP': '國際貨運平臺',
    'OFTP': '海外貨運平臺'
  },
  permission: {
    reset: '重置',
    enable: '啟用',
    disable: '禁用',
    delete: '刪除',
    deleteBatch: '批量刪除',
    remark: '備註',
    sort: '排序',
    confirm: '確定',
    cancel: '取消',
    operation: '操作',
    modify: '修改',
    select: '請選擇',
    input: '請輸入用戶編號或用戶名',
    query: '查詢',
    edit: '編輯',
    required_rule: '數據不能為空',
    success: '操作成功',
    fail: '操作失敗',
    length_rule: '長度在{min}到{max}個字符',
    deleteTip1: '請先禁用 "{name}" 下的所有子系統',
    deleteTis: '是否確認刪除名稱為 "{name}" 的數據項?',
    deleteChildTis: ' 同時該系統下的所有系統都會被刪',
    tis: '提示',
    deleteBatchTis: '確認刪除選中的{num}條數據?',
    enableTis: '確認{statusName}選中的{num}條數據?',
    msgError: '操作數據有誤',
    codeCheckRule: '允許大小寫字母、數字、"_"或"-"',
    checkMinCharacter: '請輸入{min}個以上字符',

    // 角色管理
    roleType_0: '自建角色',
    roleType_1: '系統管理員',
    bindResource: '綁定資源',
    roleList: '角色列表',
    roleAdd: '新增角色',
    roleEdit: '編輯角色',
    roleConfig: '配置角色',
    childSystemName: '子系統名稱',
    roleNo: '角色編號',
    roleName: '角色名稱',
    roleDescribe: '角色描述',
    isSystem: '所屬系統',
    roleType: '角色類型',

    // 用戶管理
    userStatus_0: '未激活',
    userStatus_1: '已激活',
    userStatus_2: '預註銷',
    userStatus_3: '已註銷',
    userStatus_4: '禁用',
    userStatus_5: '鎖定',
    userRoleEdit: '查看/編輯角色',
    userList: '用戶列表',
    regtime: '註冊時間',
    userCode: '用戶編號',
    area: '所屬地區',
    nickName: '昵稱',
    sourceSystem: '來源系統',
    userStatus: '狀態',

    // 系統管理
    systemList: '系統列表',
    systemAdd: '新增系統',
    systemModify: '修改系統',
    systemName: '系統名稱',
    systemType: '系統類型',
    systemType_0: '主數據',
    systemType_1: '業務系統',
    systemCode: '系統編碼',
    systemStatus: '系統狀態',
    systemStatus_0: '啟用',
    systemStatus_1: '禁用',
    systemAddChildren: '新增子系統',
    systemSuperior: '上級系統',

    // 資源管理
    resourceList: '資源列表',
    resourceAdd: '新增資源',
    resourceModify: '修改資源',
    resourceName: '資源名稱',
    resourceType: '資源類型',
    resourceType_MENU: '菜單',
    resourceType_MODULE: '目錄',
    resourceType_WIDGET: '按鈕',
    resourceCode: '資源編碼',
    resourceStatus: '資源狀態',
    resourceStatus_true: '啟用',
    resourceStatus_false: '禁用',
    resourceAddChildren: '新增子項',
    resourceSuperior: '上級菜單',
    icon: '圖標樣式',
    iconActive: '活動圖標',
    shortName: '簡稱',
    resourceUrl: '資源URL',
    resourceFun: '功能URL',
    openType: '打開方式',
    openType_0: '頁面路由',
    openType_1: '新窗口',
    pub: '是否需要權限控制',
    pub_true: '是',
    pub_false: '否',
    hidden: '是否隱藏',
    hidden_0: '是',
    hidden_1: '否',
    selectSystem: '請先選擇系統',
  },
  protocol: {
    num: '編號',
    protocolName: '協議名稱',
    protocolNo: '協議版本號',
    signTime: '簽署時間',
    remark: '備註',
    signUser: '簽署賬號',
    signName: '簽署客戶名稱',
    signChild: '協議子版本號',
  },
  sfbuy: {
    'wechatScane': '微信 掃一掃',
    'wechatScane1': '即時掌握',
    'wechatScane2': '包裹動態',
    'onlineService': '線上客服',
    'aboutUs': '關於我們',
    'serviceGuide': '新手指南',
    'helpCenter': '幫助中心',
    'serviceAndPrice': '服務與價格',
    'announcement': '公告',
    'important': '重要'
  },
  weakPassword: {
    提示: '提示',
    账号异常提醒: '您的帳號存在異常，請及時修改密碼，或使用驗證碼、掃碼方式登入',
    修改密码: '修改密碼',
    关闭: '關閉',
    账号异常处理: '帳號異常處理',
    绑定提示: '請先綁定手機或信箱，然後進行密碼修改',
    账号: '帳號'
  },
  twoFactorAuth: {
    双因素认证: '雙因素認證',
    认证方式: '認證方式',
    为了您的账号安全: '為了您的帳號安全，需完成雙因素認證後登入',
    请选择绑定: '請選擇綁定:',
    请先设置您的密码: '請先設置您的密碼'
  },
  sendType: {
    您当前手机区号不支持whatsapp: '您當前手機區號不支持{noticeChanel}，請選擇其他獲取驗證碼方式',
    请使用绑定手机号接收验证码: '請使用綁定手機號碼接收驗證碼',
    请使用绑定邮箱接收验证码: '請使用綁定信箱接收驗證碼',
    请选择验证码接收方式: '請選擇驗證碼接收方式'
  }
}
